<spinner *ngIf="loading"></spinner>
<div class="container-fluid">
    <div class="d-flex justify-content-between align-items-center pb-3">
        <h1 class="h4 mb-0">{{ heading }}</h1>
        <div class="d-flex align-items-center gap-2">
            @if (Permissions.CREATE_ORGANISATION | hasPermission) {
                <a class="btn btn-success" [routerLink]="newOrganisationRoute" data-testid="new-organisation-btn">
                    + New organisation
                </a>
            }
            <button #filtersButton type="button" class="btn btn-outline-secondary"
                    [attr.aria-expanded]="showFilters"
                    (click)="toggleFilters()"
                    data-testid="organisations-filters-btn">
                <i class="bi bi-funnel" aria-hidden="true"></i> Filters
            </button>
        </div>
    </div>

    @if (showFilters) {
        <div class="filter-overlay" (click)="onFilterCancel()"></div>
        <div class="filter-sidebar">
            <cdss-organisations-filter
                [(filter)]="filter"
                [canSeeInactive]="isGeneralAdmin"
                (apply)="onFilterApply()"
                (cancel)="onFilterCancel()">
            </cdss-organisations-filter>
        </div>
    }

    @if (!loading) {
        <overlay-spinner *ngIf="refreshing"></overlay-spinner>
        <div role="region" aria-labelledby="organisations-table-caption">
            <span id="organisations-table-caption" class="visually-hidden">{{ heading }}: name, code, address, city, postcode, contracts and actions</span>
            <ngx-datatable class="bootstrap mt-4" #table
                           [rows]="rows"
                           [columnMode]="'flex'"
                           [headerHeight]="50"
                           [rowHeight]="'auto'"
                           [footerHeight]="0"
                           [limit]="pagination.size"
                           [messages]="{emptyMessage: 'No records found', totalMessage: 'records found'}">

                <ngx-datatable-column prop="name" name="Name" [sortable]="false" [flexGrow]="2.5">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                        <span>{{ row.name || '-' }}</span>
                        @if (statusLabel(row); as status) {
                            <span class="badge ms-2" [class.badge-deleted]="status === 'Deleted'" [class.badge-deactivated]="status === 'Deactivated'" data-testid="organisation-status-badge">{{ status }}</span>
                        }
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column prop="code" name="Code" [sortable]="false" [flexGrow]="1.2"></ngx-datatable-column>

                <ngx-datatable-column prop="address" name="Address" [sortable]="false" [flexGrow]="2">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                        <span>{{ row.address || '-' }}</span>
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column prop="city" name="City" [sortable]="false" [flexGrow]="1.2">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                        <span>{{ row.city || '-' }}</span>
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column prop="postcode" name="Postcode" [sortable]="false" [flexGrow]="1">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                        <span>{{ row.postcode || '-' }}</span>
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Contracts" [sortable]="false" [flexGrow]="2">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                        <span>{{ contractTitles(row) }}</span>
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Action" [sortable]="false" [flexGrow]="0.8" [minWidth]="60">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                        <a class="row-action" [routerLink]="detailRoute(row)"
                           [attr.aria-label]="'Edit organisation ' + (row.name || row.code)"
                           data-testid="organisation-edit-link">
                            <i class="bi bi-pencil-square" aria-hidden="true"></i>
                        </a>
                    </ng-template>
                </ngx-datatable-column>
            </ngx-datatable>
        </div>
    }
</div>
<div class="d-flex align-items-center justify-content-between px-3 mt-2">
    <div>
        Page selector
        <button type="button" class="btn px-2" [ngClass]="{'fw-bolder': pagination.size == 25}" (click)="setPaginationSize(25)">25</button> /
        <button type="button" class="btn px-2" [ngClass]="{'fw-bolder': pagination.size == 50}" (click)="setPaginationSize(50)">50</button> /
        <button type="button" class="btn px-2" [ngClass]="{'fw-bolder': pagination.size == 100}" (click)="setPaginationSize(100)">100</button>
    </div>
    <div aria-live="polite">
        <b>{{ pagination.totalCount }} organisations</b> - Showing {{ pagination.fromRecord }}-{{ pagination.toRecord }}
    </div>
    <div>
        <button type="button" class="btn btn-success rounded-pill fw-bold me-2" [disabled]="pagination.currentPage <= 1" (click)="previousPage()">&lt; PREVIOUS PAGE</button>
        <button type="button" class="btn btn-success rounded-pill fw-bold" [disabled]="pagination.currentPage == pagination.totalPages" (click)="nextPage()">NEXT PAGE &gt;</button>
    </div>
</div>
